import { useState, useEffect } from "react";

/**
 * Tracks which step section is currently visible in the viewport.
 * Used to highlight the active TOC item as the user scrolls.
 *
 * @param {string[]} stepIds - Array of element IDs to observe (e.g. ["step-01", "step-02"])
 * @param {string} rootMargin - IntersectionObserver rootMargin (default triggers near top of viewport)
 * @returns {string} - The ID of the currently visible step
 */
export function useScrollSpy(stepIds, rootMargin = "-10% 0px -80% 0px") {
  const [activeId, setActiveId] = useState(stepIds[0] || "");

  useEffect(() => {
    if (!stepIds || stepIds.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin }
    );

    stepIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [stepIds, rootMargin]);

  return activeId;
}